
<div class="main">
    <div class="video-wrap">
        <video id="video"loop muted autoplay playsinline oncanplay="this.play()" onloadedmetadata="this.muted = true" >
            <source src="assets/videos/main.mp4" type="video/mp4" (load)="scrollTop()">
        </video>
        <div class="main-text">
            <p>
                <span>A</span><span>I</span>, <span>R</span><span>o</span>botics
                and <span>V</span>ision Technologies for Human Being
            </p>
            <p class="motto">AIROV는 인류의 정신적 가치의 풍요를 위해 끊임없이 노력하겠습니다.</p>
        </div>
    </div>
</div>

<section>
    <div class="slide-bg"></div>
    <div class="contents01">
        <div class="text" data-aos="fade-right" data-aos-duration="1500">
            <h1>AI</h1>
            <p>
                인공지능 사물인식을 위한 학습데이터 생성 기술 및 <br>인식 알고리즘 기술을 만들어갑니다.
            </p>
        </div>
    
        <div class="imgslide">
            <div class="slide-introduction">
                <input type="radio" name="slide2" id="slide04" checked> <input
                    type="radio" name="slide2" id="slide07">
                <ul class="introduction" id="slides">
                    <li class="slide-content 01"><a routerLink="/company/technology-ai01">
                            <span> <img src="assets/images/slide01.png"
                                data-aos="flip-up">
                                <h2>01</h2> <em>"사물 인식 학습 데이터 생성기술"</em>
                                <p class="xi-plus"></p>
                        </span>
                    </a></li>
                    <li class="slide-content 02"><a routerLink="/company/technology-ai02">
                            <span> <img src="assets/images/slide02.png"
                                data-aos="flip-up">
                                <h2>02</h2> <em>실시간 당구공, 큐대인식</em>
                                <p class="xi-plus"></p>
                        </span>
                    </a></li>
                    <li class="slide-content 03"><a routerLink="/company/technology-ai04">
                            <span> <img src="assets/images/slide04.png"
                                data-aos="flip-up">
                                <h2>03</h2> <em>실시간 팜터치(Palm Touch) 인식</em>
                                <p class="xi-plus"></p>
                        </span>
                    </a></li>
                    <li class="slide-content 04"><a routerLink="/company/technology-ai03">
                            <span> <img src="assets/images/slide03.png"
                                data-aos="flip-up">
                                <h2>04</h2> <em>자율주행용 사물인식</em>
                                <p class="xi-plus"></p>
                        </span>
                    </a></li>
                    <li class="slide-content 05"><a routerLink="/company/technology-ai05">
                            <span> <img src="assets/images/slide05.png"
                                data-aos="flip-up">
                                <h2>05</h2> <em>피킹 로봇용 3D 사물 인식</em>
                                <p class="xi-plus"></p>
                        </span>
                    </a></li>
                </ul>
                <div class="slide-introduction-control" data-aos="fade-left"
                    data-aos-duration="1500">
                    <div>
                        <label for="slide07" class="left"></label> <label for="slide07"
                            class="right"></label>
                    </div>
                    <div>
                        <label for="slide04" class="left"></label> <label for="slide04"
                            class="right"></label>
                    </div>
                </div>
                <div class="slide-introduction-control-mobile" data-aos="fade-left"
                    data-aos-duration="1500">
                    <div>
                        <label class="left" (click) = "prevBtn()"></label> 
                        <label class="right" (click) = "nextBtn()"></label>
                    </div>
                </div>                
            </div>
        </div>
    </div>
    <div class="contents02">
        <canvas id="pixie"></canvas>
        <div class="text" data-aos="fade-left" data-aos-duration="1500">
            <h1>Robotics</h1>
            <p>
                인공지능과 영상처리 기술을 이용한 <br>로봇 제어 알고리즘 기술을 만들어갑니다.
            </p>
        </div>
        <div class="circle-wrap">
            <div class="circle01" data-aos="fade-right" data-aos-duration="1500">
                <div class="bgc"></div>
                <div class="image">
                    <a routerLink="/company/technology-ro01"> <img
                        src="assets/images/circle01.png">
                        <h2>01</h2> <em>피킹 로봇용 다양한 사물에 대한 그래스프 플랜닝<br>(Grasp Planning)
                    </em> <a routerLink="#" class="xi-plus"></a>
                    </a>
                </div> 
            </div>
            <div class="circle02" data-aos="fade-left" data-aos-duration="1500">
                <div class="bgc"></div>
                <div class="image">
                    <a routerLink="/company/technology-ro02"> <img
                        src="assets/images/circle02.png">
                        <h2>02</h2> <em>물류 자동화 로봇 시스템 최적화 제어 디스패치 플랜닝<br>(Dispatch
                            Planning)
                    </em> <a routerLink="#" class="xi-plus"></a>
                    </a>
                </div>
            </div>
            <div class="circle03">
                <div class="bgc"></div>
                <div class="image"></div>
            </div>
            <div class="circle04">
                <div class="bgc"></div>
                <div class="image"></div>
            </div>
        </div>
    </div>
    <div class="contents03">
        <div class="video-wrap">
            <video muted autoplay loop playsinline>
                <source src="assets/videos/vision.mp4" type="video/mp4">
            </video>
            <div class="main-text" data-aos="fade-down">
                <p>Vision</p>
                <p class="motto">
                    영상 처리를 통한 형상 및 <br>좌표인식 알고리즘 기술을 만들어 갑니다.
                </p>
                <a routerLink="/company/technology-vi01" class="xi-plus-thin">More</a>
            </div>
        </div>
    </div>
</section>\